export { strings } from './en'
